import React from "react";
import { useBotStore, TAB_OPTIONS } from "../stores/botStore";
import { RefreshButton } from "components";

// Компонент заголовку сторінки "Керування ботом"
const BotHeader = () => {
  const activeTab = useBotStore((state) => state.activeTab);
  const setActiveTab = useBotStore((state) => state.setActiveTab);
  const isLoading = useBotStore((state) => state.isLoading);
  const fetchActiveTabData = useBotStore((state) => state.fetchActiveTabData);

  // Знаходимо назву поточної та наступної вкладки
  const toggleButtonLabel =
    TAB_OPTIONS.find((t) => t.id === activeTab)?.toggle_name || "Меню";

  const handleToggleTab = () => {
    // Якщо поточна settings -> перемикаємо на queue, і навпаки
    const nextTabId = activeTab === "settings" ? "queue" : "settings";
    setActiveTab(nextTabId);
  };

  return (
    <div className="botsettingspage-title">
      <div className="botsettingspage-title-line">
        <div className="title-container">
          <RefreshButton onRefresh={fetchActiveTabData} disabled={isLoading} />
          <h3>Керування ботом</h3>
        </div>

        <div className="title-container">
          <button
            className={`focus-button toggle-tab-button ${activeTab}`}
            onClick={handleToggleTab}
            title="Змінити розділ"
          >
            {toggleButtonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BotHeader;
